(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["concept-demo-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.bar-menu').forEach(function(menu) {
  var cards = Array.from(menu.querySelectorAll('.menu-card'));
  var filters = menu.querySelectorAll('.menu-filter');
  filters.forEach(function(filter) {
    filter.addEventListener('click', function() {
      var category = filter.dataset.menuCategory;
      var visible = 0;
      cards.forEach(function(card) {
        card.hidden = category !== 'all' && card.dataset.category !== category;
        if (!card.hidden) visible++;
      });
      filters.forEach(function(item) { item.setAttribute('aria-pressed', String(item === filter)); });
      menu.querySelector('.bar-menu__count').textContent = visible + ' / ' + cards.length;
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
